<p-dialog 
  header="Sr. prestador, actualice su correo electrónico" 
  [(visible)]="display" 
  (onHide)="closeModal()" 
  [modal]="true" 
  [draggable]="false" 
  [resizable]="false"
  [closable]="false"
  styleClass="p-dialog-firma-custom" 
  [style]="{width: '500px'}">
  
  <div class="modal-email-content">
    <form [formGroup]="emailForm">
      <div class="field">
        <label for="email">Por favor, ingrese su correo electrónico:</label>
        <input 
          id="email"
          type="email" 
          pInputText 
          formControlName="email"
          placeholder="ejemplo@correo.com"
          [style]="{width: '100%', marginTop: '0.5rem'}"
        />
        <small 
          class="p-error" 
          *ngIf="emailForm.get('email')?.invalid && emailForm.get('email')?.touched">
          <span *ngIf="emailForm.get('email')?.errors?.['email'] || emailForm.get('email')?.errors?.['required']">Ingrese un correo electrónico válido</span>
          <span *ngIf="emailForm.get('email')?.errors?.['serverError']">{{ emailForm.get('email')?.errors?.['serverError'] }}</span>
        </small>
      </div>
    </form>
  </div>

  <p-footer>
    <div style="display: flex; justify-content: flex-end; gap: 0.5rem;">
      <p-button 
        label="Cancelar" 
        (click)="closeModal()" 
        styleClass="p-button-secondary"
        [disabled]="loading">
      </p-button>
      <p-button 
        label="Enviar" 
        (click)="submitEmail()" 
        [disabled]="loading"
        [loading]="loading">
      </p-button>
    </div>
  </p-footer>
</p-dialog>
